import { createAction, props } from '@ngrx/store';
import { IProducts } from '../models/products.model';

export const loadPastProductsFromSomeoneElse = createAction(
  '[PastProductsFromSomeoneElse] Load PastProductsFromSomeoneElse',
  props<{ request: string }>()
);

export const loadPastProductsFromSomeoneElseSuccess = createAction(
  '[PastProductsFromSomeoneElse] Load PastProductsFromSomeoneElse Success',
  props<{ response: IProducts[] }>()
);

export const loadPastProductsFromSomeoneElseFailure = createAction(
  '[PastProductsFromSomeoneElse] Load PastProductsFromSomeoneElse Failure',
  props<{ error: Error | any }>()
);
